import { printUrl } from '../../popups'
import { num2str } from '../../tools/math'

const PRIHOD_HEADERS = {
  firm: 'Пост',
  data: 'Дата',
  summa: 'Сумма',
  __plat: 'Плательщик',
  nscheta: 'Счет',
  is_opl: 'Опл',
  nds_: 'НДС, %',
  predopl_str: 'Предоплата',
}

const RASHOD_HEADERS = {
  nomer: 'Счет',
  data: 'Дата',
  __verbose__firms: 'Субконтрактор',
  __verbose__type: 'Услуга',
  summa: 'Сумма, руб.',
  sumnds: 'В том числе НДС, руб.',
  opl: 'Опл',
  nds_: 'НДС, %',
}

function getIdFromUrl() {
  const href = window.location.hash
  const results = /zays\/(\d+)\/finansy/.exec(href)
  if (results) {
    return results[1]
  }
  return null
}

function ZayFinansyController(
  $q,
  $scope,
  uchetService,
  zatratiService,
  zaysService,
  uchetModal,
  zatratiModal,
  zoplModal,
  firmServiceApiV2,
  uslugiService,
  zaysServiceApiV2,
  popup
) {
  const vm = {}
  $scope.vm = vm
  let modal

  // vm.popup = popupService

  vm.id = getIdFromUrl()
  vm.active = 'dohod'

  vm.ourFirms = []

  vm.prihod = {
    prognoz: 0,
    balans: 0,
    ostatok: 0,
    table: {
      opts: {
        headers: PRIHOD_HEADERS,
      },
      init$: $q.defer(),
      selected: null,
      service: uchetService,
      ctrl: null,
      rowfmt: function (r) {
        if (('' + r.nds).trim() !== '') {
          r.nds_ = num2str(parseFloat(r.nds) * 100)
        } else {
          r.nds_ = 'н/о'
        }
        r.data = $.fn.dateutils.date2str_ddmmyyyy(r.data, '.')

        if (r.nzopls > 0 && r.nzoplrefs > 0) {
          r.predopl_str = 'ошибочный'
        } else if (r.nzopls > 0) {
          r.predopl_str = `итоговый (${r.nzopls})`
        } else if (r.nzoplrefs > 0) {
          r.predopl_str = 'предоплата'
        }

        return r
      },
    },
  }
  Object.defineProperty(vm.prihod.table, 'selectedObject', {
    get: () => {
      const ctrl = vm.prihod.table.ctrl
      if (!ctrl || !ctrl.rows) {
        return undefined
      }
      return ctrl.rows.find((r) => r.id === vm.prihod.table.selected)
    },
  })

  Object.defineProperty(self, 'uchet', {
    get: () => vm.prihod.table.selectedObject,
  })

  vm.rashod = {
    prognoz: 0,
    uchten: false,
    table: {
      opts: {
        headers: RASHOD_HEADERS,
      },
      init$: $q.defer(),
      selected: null,
      service: zatratiService,
      ctrl: null,
      rowfmt: function (r) {
        r.data = $.fn.dateutils.date2str_ddmmyyyy(r.data, '.')

        if (isNaN(r.nds) || r.nds === '') {
          r.sumnds = 'н/о'
        } else {
          const sumnds = r.summa - r.summa / (1 + r.nds / 100.0)
          r.sumnds = (Math.round(sumnds * 100) / 100).toFixed(2)
        }

        r.nds_ = ('' + r.nds).trim() === '' ? 'н/о' : r.nds

        r.opl = r.plat ? '+' : '-'
        return r
      },
    },
  }

  const promises = [
    vm.prihod.table.init$.promise,
    vm.rashod.table.init$.promise,
    zaysService.get({ id: vm.id, __verbose: 1 }),
    firmServiceApiV2.get({ kmbm__nashi: 1 }).then((page) => page.results),
    zaysServiceApiV2.get({ id: vm.id }),
  ]
  $q.all(promises).then((resps) => {
    vm.prihod.table.ctrl = resps[0]
    vm.rashod.table.ctrl = resps[1]
    vm.zay = resps[2]
    vm.zayV2 = resps[4]
    vm.ourFirms = resps[3].filter((f) => f.kmbm !== 'tm')

    return $q.all([reloadPrihod(), reloadRashod()]).then((resps) => {
      $scope.$watch('vm.prihod.table.ctrl.lastModDate', (nv, ov) => {
        zaysService.get({ id: vm.id, __verbose: 1 }).then((zay) => {
          vm.zay = zay
        })
      })

      $scope.$watch('vm.rashod.table.ctrl.lastModDate', (nv, ov) => {
        zaysService.get({ id: vm.id, __verbose: 1 }).then((zay) => {
          vm.zay = zay
        })
      })
    })
  })

  vm.savePrihodPrognoz = () => {
    zaysServiceApiV2
      .patch({ id: vm.zay.id, dohod: vm.zay.dohod })
      .then((zay) => {
        vm.zay = zay
      })
  }

  vm.saveRashodPrognoz = () => {
    zaysServiceApiV2
      .patch({ id: vm.zay.id, rashod: vm.zay.rashod })
      .then((zay) => {
        vm.zay = zay
      })
  }

  vm.editPrihodUchet = (id) => {
    modal = uchetModal.open({
      locals: {
        uchet: getPrihodUchet(id),
        zay: vm.zay,
        type: 'prihod',
        ourfirms: [],
      },
    })
    modal.opened.then(focusOnSum)
    modal.closed.then(vm.prihod.table.ctrl.addOrUpdateRow)
  }

  vm.deletePrihodUchet = (id) => {
    if (!confirm('Вы уверены, что хотите удалить счет?')) {
      return
    }
    getPrihodUchet(id)
    vm.prihod.table.ctrl.remove(id)
    return reloadPrihod()
  }

  vm.editRashodUchet = (id) => {
    // в зависимости от строки редактируем либо учет, либо затраты
    const rashod = getRashodRow(id)
    return getUchetFromRashod(rashod).then((uchet) => {
      if (!rashod || !!uchet) {
        // этот счет должен быть сразу же оформлен как "счет субконтрактора"
        // TODO в бэкенде должна быть предусмотрена возможность оформления
        // счета как счета субконтратора за одну транзакцию
        // modal = Popeye.openModal(Object.assign(uchetModal, {
        modal = uchetModal.open({
          locals: {
            zay: vm.zay,
            type: 'rashod',
          },
          resolve: {
            uchet: () => (rashod ? getUchetFromRashod(rashod) : $.when(null)),
            ourfirms: () =>
              firmServiceApiV2
                .get({ kmbm__nashi: 1 })
                .then((page) => page.results),
          },
        })
        modal.opened.then(focusOnSum)
        modal.closed.then(getRashodFromUchet).then((zatrati) => {
          if (!zatrati) {
            return
          }
          if (zatrati.length > 1 || zatrati.length === 0) {
            return
          }
          vm.rashod.table.ctrl.addOrUpdateRow(zatrati[0])
        })
      } else {
        return vm.editZatrati(rashod)
      }
    })
  }

  vm.editZatrati = (rashod) => {
    if (!isNaN(rashod)) {
      // eslint-disable-next-line no-undef
      rashod = getRashodRow(id)
    }

    modal = zatratiModal.open({
      locals: {
        subschet: rashod,
        zay: vm.zay,
        options: null,
      },
      resolve: {
        usltypes: () => uslugiService.get({}),
      },
    })
    modal.opened.then(focusOnSum)
    modal.closed.then(vm.rashod.table.ctrl.addOrUpdateRow)
  }

  vm.editZopl = (id) => {
    const uchet = getPrihodUchet(id)
    if (uchet.nzoplrefs > 0) {
      if (confirm('Отменить предоплату?')) {
        return uchetService.deleteZopl(uchet).then(reloadPrihod)
      }
    } else {
      modal = zoplModal.open({
        locals: {
          uchet,
          firmUchet: vm.prihod.table.ctrl.rows,
        },
      })
      // обновим предоплатный и итоговый счета
      modal.closed.then(reloadPrihod)
    }
  }

  vm.deleteRashodUchet = (id) => {
    const rashod = getRashodRow(id)
    return getUchetFromRashod(rashod).then((uchet) => {
      if (uchet) {
        if (
          confirm(
            `Будет удален счет субконтратора ${rashod.nomer} ` +
              `и связанный с ним внутренний счет ${uchet.nscheta} ` +
              `по фирме ${uchet.firm} на сумму ${uchet.summa} руб.`
          )
        ) {
          return uchetService.delete(uchet.id).then(() => {
            vm.rashod.table.ctrl.removeRow(id)
          })
        }
      } else {
        if (confirm(`Будет удален счет субконтрактора ${rashod.nomer}`)) {
          return vm.rashod.table.ctrl.remove(id)
        }
      }
    })
  }

  vm.printZakaz2 = () => {
    zaysServiceApiV2.expZakazReport(vm.id)
    return false
  }

  vm.printZay = (type) => {
    printUrl(
      `print2.php?path=z_print2.php&id=${vm.id}&nscheta=` + `&type=${type}`
    )
    return false
  }

  vm.printFullRasklad = () => {
    printUrl(`print2.php?path=z_print3.php&id=${vm.id}`)
    return false
  }

  vm.editNewWin = (zayid) => {
    console.log(zayid)
    popup.state('zay.base.detail', { id: zayid }, 1024, 768)
    return false
  }

  function getUchetFromRashod(rashod) {
    if (!rashod) {
      return $q.resolve(null)
    }
    return firmServiceApiV2.get({ id: rashod.firms }).then((firm) => {
      if (firm.kmbm === 'N') {
        return null
      }
      const nscheta = rashod.nomer.substring(1)
      return uchetService.get({ nscheta, firm: firm.kmbm }).then((uchets) => {
        return uchets[0]
      })
    })
  }

  function getRashodFromUchet(uchet) {
    if (!uchet) {
      return $q.resolve(null)
    }
    return zatratiService.get({
      nomer: `T${uchet.nscheta}`,
      zay: uchet.pid,
      kmbm: uchet.firm,
      __verbose: 1,
    })
  }

  function getPrihodUchet(id) {
    return id ? vm.prihod.table.ctrl.getRow(id) : null
  }

  function getRashodRow(id) {
    return id ? vm.rashod.table.ctrl.getRow(id) : null
  }

  function focusOnSum() {
    modal.element.find('input[name=summa]').focus()
  }

  function reloadPrihod() {
    // не покажет внутренние счета по данной заявке, т.к. они
    // выставлены от другой фирмы
    // TODO запретить выставлять внутренний счет от фирмы,
    // обрабатывающей данную заявку (чтобы внутренний счет
    // не отобразился в "приходе") - или пока не надо?
    return vm.prihod.table.ctrl.load({
      firm: vm.zay.type,
      zay: vm.id,
      __verbose__plat: 1,
      __verbose__subschet: 1,
      __verbose__nzopls: 1,
      __verbose__opl: 1,
    })
  }

  function reloadRashod() {
    return vm.rashod.table.ctrl.load({ zay: vm.id, __verbose: 1 })
  }
}

export const ZayFinansyComponent = {
  template: require('./zay-finansy.component.html'),
  styles: [require('./zay-finansy.component.scss')],
  bindings: {
    zay: '<',
  },
  controller: ZayFinansyController,
  controllerAs: 'vm',
}
